import { render, staticRenderFns } from "./assessment-card.vue?vue&type=template&id=110a9797&"
import script from "./assessment-card.vue?vue&type=script&lang=js&"
export * from "./assessment-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports